module.exports = __webpack_public_path__ + "./docs/img/chevron_down.2f01854d6e9e1b62506172a0eecd7390.svg";